import omitDeep from "omit-deep-lodash";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "utils/constants";
import View from "./View";

const EditOffer = ({ id, onClose }) => {
  const [updateOffer] = useMutation(graphql.mutations.UPDATE_OFFER, {
    refetchQueries: [
      {
        query: graphql.queries.OFFERS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
    ],
    onCompleted: () => onClose(),
  });
  const { data, loading } = useQuery(graphql.queries.OFFER, {
    variables: { where: { id } },
    skip: !id,
  });

  const onSubmit = ({ processes = [], ...data }) => {
    updateOffer({
      variables: {
        where: { id },
        data: {
          ...data,
          processes: processes?.map((id) => ({ id })),
        },
      },
    });
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <View
      open={!!id}
      onClose={onClose}
      onSubmit={onSubmit}
      data={omitDeep(data?.offer, "__typename")}
    />
  );
};

export default EditOffer;
